import React from 'react';
import { Button } from './ui/Button';
export function NavBar() {
  return <nav className="w-full sticky top-0 z-50" style={{
    backgroundColor: '#bc8a60'
  }} data-id="element-10">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-14 flex items-center relative" data-id="element-11">
        {/* Centered title */}
        <div className="absolute left-1/2 -translate-x-1/2" data-id="element-12">
          <span className="text-xs font-bold tracking-widest uppercase text-white" data-id="element-13">
            Joint Health Insider
          </span>
        </div>
        {/* Right-aligned button */}
        <div className="ml-auto" data-id="element-14">
          <Button variant="outline" size="sm" className="text-xs font-semibold border-white bg-white text-slate-800 hover:bg-gray-100" onClick={() => window.open('https://ventoropro.com/products/copperease-bracelet-1', '_blank')} data-id="element-15">
            CopperEase Bracelet
          </Button>
        </div>
      </div>
    </nav>;
}